import React, { useRef, useState } from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";
import UIModal from "../../../Domain/Components/UI/Modal/Modal";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { toast } from "react-toastify";
import { postApiCall, postFileApiCall } from "../../../Infrastructure/Helpers/HttpHandler";
import { useNavigate } from "react-router-dom";

function CampaignGameConfigListPage(props) {
    const navigate = useNavigate();
    const bulkInsertGameConfigs = () => {
            navigate("/campaign-gameconfig/attach");
       };

    return(
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            deleteModalTitile={"Delete Campaign Game Config"}
                            deleteModalQuestion={"Are you sure you want to delete this campaign game config?"}
                            editHref={"/campaign-gameconfig/update"}
                            detailsHref={"/campaign-gameconfig/details"}
                            objectKeys={["id", "campaign.name", "operator_game_config.internal_game_id" , "operator_game_config.game_config.name"]}
                            columnTitles={[ 
                                "ID", "Campaign", "Internal Game ID", "Game Name"
                            ]}
                            insertHref={"/campaign-gameconfig/create"}
                            insertTitle={"Add Campaign Game Config"}
                            pageTitle={"Campaign Game Configs"}
                            deleteEndpoint={"campaign-operator-gameconfig/delete"}
                            readEndpoint={"campaign-operator-gameconfig/read"}
                            relations={["campaign", "operator_game_config" , "operator_game_config.game_config"]}
                            buttonData={[
                                {
                                    title: "Bulk insert Provider Games",
                                    onClick: bulkInsertGameConfigs
                                }
                            ]}
                            />
        </>
    )
}

export default CampaignGameConfigListPage;